import { Head } from '@inertiajs/react'
import { DealsTable } from "@/components/deals-table"

export default function Drafts() {
  return (
    <>
      <Head title="Draft Deals" />
      <DealsTable title="Draft Deals" subtitle="Imported from Salesforce and waiting for team to add details" />
    </>
  )
}
